import axios from 'axios';
import { Producto } from '../types';
import { inventarioInicial } from '../data/inventarioInicial';

const GOOGLE_SHEETS_API_KEY = process.env.REACT_APP_GOOGLE_SHEETS_API_KEY;
const SPREADSHEET_ID = '1U-xbNdzE8IcDExMhJgyo7Z-JLLcYPwdG76O1NV-nt5k';

export interface GoogleSheetRow {
  Fecha?: string;
  Categoría?: string;
  Producto?: string;
  Unidad?: string;
  Proveedor?: string;
  Entradas?: string;
  'Fecha de entrada'?: string;
  'Fecha de caducidad'?: string;
  Salidas?: string;
  Mermas?: string;
  'Stock final'?: string;
  'Stock mínimo'?: string;
  'Punto de pedido'?: string;
}

class GoogleSheetsService {
  private baseUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}`;

  async getMockData(): Promise<Producto[]> {
    return inventarioInicial;
  }

  async fetchProductsFromSheet(): Promise<Producto[]> {
    try {
      if (!GOOGLE_SHEETS_API_KEY) {
        console.warn('Google Sheets API key no está configurada. Usando datos mock.');
        return inventarioInicial;
      }

      const response = await axios.get(
        `${this.baseUrl}/values/A1:M100?key=${GOOGLE_SHEETS_API_KEY}`
      );

      const rows = response.data.values;
      if (!rows || rows.length === 0) {
        console.warn('No hay datos en Google Sheets o la hoja está vacía. Usando datos mock.');
        return inventarioInicial;
      }

      const headers = rows[0];
      const dataRows = rows.slice(1);

      const productos: Producto[] = dataRows
        .filter((row: any[]) => row.length > 0 && row[0])
        .map((row: any[], index: number) => {
          const rowData: any = {};
          headers.forEach((header: string, i: number) => {
            rowData[header] = row[i] || '';
          });

          const stockMinimo = parseFloat(rowData['Stock mínimo']) || 0;
          return {
            id: `sheet-${index}`,
            fecha: rowData['Fecha'] || '',
            categoria: rowData['Categoría'] || '',
            producto: rowData['Producto'] || '',
            unidad: rowData['Unidad'] || '',
            proveedor: rowData['Proveedor'] || '',
            entradas: parseFloat(rowData['Entradas']) || 0,
            fechaEntrada: rowData['Fecha de entrada'] || '',
            fechaCaducidad: rowData['Fecha de caducidad'] || '',
            salidas: parseFloat(rowData['Salidas']) || 0,
            mermas: parseFloat(rowData['Mermas']) || 0,
            stockFinal: parseFloat(rowData['Stock final']) || 0,
            stockMinimo: stockMinimo,
            stockMaximo: parseFloat(rowData['Stock máximo']) || (stockMinimo * 3),
            puntoReorden: parseFloat(rowData['Punto de pedido']) || 0,
          };
        });

      return productos;
    } catch (error: any) {
      if (error.response?.status === 403) {
        console.warn('Acceso denegado a Google Sheets. Verifica que la hoja sea pública o que tengas permisos. Usando datos mock.');
      } else if (error.response?.status === 400) {
        console.warn('Error en la configuración de Google Sheets API. Verifica el ID de la hoja y el rango. Usando datos mock.');
      } else {
        console.error('Error fetching data from Google Sheets:', error);
      }
      return inventarioInicial;
    }
  }

  async updateProductInSheet(producto: Producto, rowIndex: number): Promise<boolean> {
    try {
      if (!GOOGLE_SHEETS_API_KEY) {
        console.warn('Google Sheets API key no está configurada. No se puede actualizar.');
        return false;
      }

      const values = [
        [
          producto.fecha,
          producto.categoria,
          producto.producto,
          producto.unidad,
          producto.proveedor,
          producto.entradas,
          producto.fechaEntrada,
          producto.fechaCaducidad,
          producto.salidas,
          producto.mermas,
          producto.stockFinal,
          producto.stockMinimo,
          producto.puntoReorden
        ]
      ];

      await axios.put(
        `${this.baseUrl}/values/Sheet1!A${rowIndex + 2}:M${rowIndex + 2}?valueInputOption=RAW&key=${GOOGLE_SHEETS_API_KEY}`,
        { values }
      );

      return true;
    } catch (error) {
      console.error('Error updating Google Sheets:', error);
      return false;
    }
  }

}

export const googleSheetsService = new GoogleSheetsService();